<p class="modal-title">
  Admin: @if (isAdd()) {Add} @else {Edit} Price Item
</p>
<div class="body flex flex-col">
  <form [formGroup]="itemForm" (ngSubmit)="onSubmit()" #itemFormRef="ngForm">
    <app-form-field
      [label]="'Name'"
      [formControl]="name"
      [errorType]="'outline'"
      [id]="'name'"
      [placeholder]="'Enter item name...'"
      [error]="!name.valid && itemFormRef['submitted'] ? 'Field is required' : ''"
    />

    @if (scrapeData(); as data) {
      <app-scrape-panel
        [data]="data"
        (apply)="applySuggestedFromChild($event)"
      />
    }

    <div class="action-row">
      <button
        type="button"
        class="button button--style-primary h-36 padding-x-12 scrape-btn"
        [disabled]="!canScrape() || scrapeLoading()"
        (click)="onScrape()"
      >
        @if (scrapeLoading()) {
          <app-loading-icon [color]="'white'" [size]="'16px'" />
          @if (scrapeStillWorking()) {
            Still scraping…
          } @else {
            Scraping...
          }
        } @else {
          Scrape Skin
        }
      </button>
      <app-form-field
        [label]="'Price (USD)'"
        [formControl]="price"
        [errorType]="'outline'"
        [id]="'price'"
        [placeholder]="'Enter price...'"
        [type]="'number'"
        [error]="!price.valid && itemFormRef['submitted'] ? 'Field is required' : ''"
      />
      <button class="button button--style-yellow h-36 padding-x-12" type="submit">
        @if (isAdd()) {Add} @else {Save} Item
      </button>
    </div>

    <div>
      <label class="field-label">Category</label>
      <app-select
        [options]="categoryOptions"
        [selected]="selectedCategory()"
      />
    </div>
    <app-form-field
      [label]="'Link (optional)'"
      [formControl]="link"
      [errorType]="'outline'"
      [id]="'link'"
      [placeholder]="'Enter backpack.tf link...'"
    />
    <app-form-field
      [label]="'Image URL (optional)'"
      [formControl]="image"
      [errorType]="'outline'"
      [id]="'image'"
      [placeholder]="'Enter image URL...'"
    />
  </form>
</div>
